import {Col, Row, Tag, Tooltip, Typography} from "antd";
import React from "react";
import {useCourierOnboarding} from "hooks/useCourierOnboarding";
export const CourierInfoRow = ({courier}) => {
    const {renderOnboardingStatus, renderOnboardingSubStatus} = useCourierOnboarding();

    const activityColors = {
        active: "#377c02",
        inactive: "#ff0f00"
    };

    const onboardingStatusColors = {
        candidateCandidate: "#fe8207",
        candidate: "#fe8207",
        blocked: "#ff0f00",
        isRejected: "#ff0f00",
        approved: "#377c02"
    };

    return (
        <Row>
            <div>
                <Typography.Title level={5}>{courier.fullname}</Typography.Title>
            </div>
            <div style={{marginLeft: "16px"}}>
                <Tooltip title="Kurye Durumu">
                    <Tag color={activityColors[courier?.disabled ? "inactive" : "active"]}>
                        {courier?.disabled ? "İnaktif" : "Aktif"}
                    </Tag>
                </Tooltip>
                <Tooltip title="İşe Alım Durumu">
                    <Tag color={onboardingStatusColors?.[courier?.onboardingStatus]}>
                        {renderOnboardingStatus({
                            onboardingStatus: courier.onboardingStatus,
                            isApplicationRejected: courier.isApplicationRejected
                        })}
                    </Tag>
                </Tooltip>

                <Tooltip title="İşe Alım Alt Durumu">
                    <Tag>
                        {renderOnboardingSubStatus({
                            onboardingSubStatus: courier.onboardingSubStatus,
                            isApplicationRejected: courier.isApplicationRejected,
                            onboardingStatus: courier.onboardingStatus
                        })}
                    </Tag>
                </Tooltip>
                <Tooltip title="Adli Sicil Kaydı">
                    <Tag>
                        {courier?.hasCriminalRecord
                            ? "Adli Sicil Kaydı Var"
                            : "Adli Sicil Kaydı Yok"}
                    </Tag>
                </Tooltip>
            </div>
        </Row>
    );
};
